export const ORDERED_LIST_STYLE_TYPES = [
  'decimal',
  'upper-latin',
  'lower-roman',
  'lower-latin',
];

export const UNORDERED_LIST_STYLE_TYPES = ['disc', 'circle', 'square'];
